import classes from "./BlackArea.module.css"
import {useEffect, useState} from "react";
import {AppStatus} from "./App";

type Props = {
    setTargetColor: (red: number, green: number, blue: number) => void
    tryCountUp: () => void
    targetColor: number[] | undefined
    setAppStatus: (appStatus: AppStatus) => void
}

const BlackArea = ({setTargetColor, tryCountUp, targetColor, setAppStatus}: Props) => {
    const [blackList, setBlackList] = useState<number[][]>([])

    useEffect(() => {
        const resultPallet: number[][] = []
        let red = 0x0
        let green = 0x0
        let blue = 0x0
        for (let index = 0; index < 100; index++) {
            for (let i = 0; i < 3; i++) {
                if (i === 0) {
                    red++
                } else if (i === 1) {
                    green++
                } else {
                    blue++
                }
                resultPallet.push([red, green, blue])
            }
        }
        setBlackList(shuffle(resultPallet))
    }, [])

    useEffect(() => {
        const targetIndex: number = Math.floor(Math.random() * blackList.length)
        if (blackList[targetIndex] !== undefined) {
            setTargetColor(blackList[targetIndex][0], blackList[targetIndex][1], blackList[targetIndex][2])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blackList])

    const createColorCode = (titleText: string): string => {
        let replaceTitleText = titleText.replace("rgb(", "");
        replaceTitleText = replaceTitleText.replace(")", "");
        const rgbList = replaceTitleText.split(",");

        let r = parseInt(rgbList[0]).toString(16)
        let g = parseInt(rgbList[1]).toString(16)
        let b = parseInt(rgbList[2]).toString(16)

        if (r.length === 1) r = "0" + r
        if (g.length === 1) g = "0" + g
        if (b.length === 1) b = "0" + b

        const colorCode = `#${r}${g}${b}`
        return colorCode
    }

    const clickBlackItem = (e: any) => {
        tryCountUp()
        const color: string = targetColor ? colorTitle(targetColor) : ""
        const titleTextRgb = e.target.id
        const flag: number = color.indexOf(titleTextRgb)
        if (flag !== -1) {
            setAppStatus("waitingResult")
            e.target.animate([
                    {
                        offset: 0,
                        scale: "1"
                    },
                    {
                        offset: 0.5,
                        scale: "1.2"
                    },
                    {
                        offset: 1.0,
                        scale: "1"
                    }
                ],
                {
                    duration: 500,
                    iterations: Infinity,
                }
            );

            const blackAreaElement =  document.getElementById("blackArea")!
            const blackItemList =  Array.from(blackAreaElement.children)

            blackItemList.forEach((blackItem)=>{
                const ele = blackItem as HTMLElement
                ele.style.pointerEvents = "none"

                const titleTextRgb = blackItem.id
                const flag: number = color.indexOf(titleTextRgb)

                if (flag === -1) { //正解以外のブラックアイテムにクラス追加
                    const offsetTime: number = Math.floor(Math.random() * 2000)
                    setTimeout(()=>{
                        blackItem.animate([
                                {
                                    offset: 0,
                                },
                                {
                                    offset: 1.0,
                                    scale: 0
                                }
                            ],
                            {
                                duration: 2000,
                                iterations: 1,
                                fill: "forwards"
                            }
                        );
                    },offsetTime)
                }
            })

            setTimeout(() => {
                setAppStatus("result")
            }, 6000)

        } else {
            e.target.className = classes.itemRemove

            //popup作成
            const popupElement = document.createElement("div")
            popupElement.className = classes.popup
            const infoTextElement = document.createElement("div")
            infoTextElement.innerText = "ハズレ"
            popupElement.append(infoTextElement)
            const resultTextElement = document.createElement("div")
            resultTextElement.innerText = `選んだ色：${createColorCode(e.target.id)}`
            popupElement.append(resultTextElement)

            const rootElement = document.getElementById("root")!
            rootElement.appendChild(popupElement)

            //penaltyPopup作成
            const timeTextElement =  document.getElementById("timeText")!
            const clientRect = timeTextElement.getBoundingClientRect()

            const penaltyPopupElement = document.createElement("div")
            penaltyPopupElement.className = classes.penaltyPopup
            penaltyPopupElement.innerText = "+10秒"
            penaltyPopupElement.style.position = "fixed"
            penaltyPopupElement.style.left =  `${clientRect.left + clientRect.width}px`
            penaltyPopupElement.style.top =  `${clientRect.top}px`

            rootElement.appendChild(penaltyPopupElement)

            setTimeout(() => {
                popupElement.remove()
                penaltyPopupElement.remove()
            }, 1500)
        }
    }

    const shuffle = ([...array]) => {
        for (let i = array.length - 1; i >= 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array
    }

    const colorTitle = (text: number[]): string => {
        return `rgb(${text[0]}, ${text[1]}, ${text[2]})`
    }

    const black300 = (): JSX.Element[] => {
        const result: JSX.Element[] = []

        for (let index = 0; index < blackList.length; index++) {
            const selectColor = blackList[index]
            result.push(
                <div className={classes.item}
                     key={index}
                     id={colorTitle(selectColor)}
                     onClick={(e) => clickBlackItem(e)}
                     style={{backgroundColor: `rgb(${selectColor[0]},${selectColor[1]},${selectColor[2]})`}}></div>
            )
        }
        return result
    }

    return (
        <div className={classes.list} id="blackArea">
            {black300()}
        </div>
    )
}

export default BlackArea